<header class="page-header">
	<h2>Firm Details</h2>
</header>

<ui-section [collapsable]="false" title="Firm Defaults">
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-y-6">
			<ng-container
				*ngIf="
					(visibleTemplates$ | async) === VisibleTemplates.HTML ||
					(visibleTemplates$ | async) === VisibleTemplates.HTML_WORD
				"
			>
				<ui-button
					label="Edit Letterhead"
					preset="EXTRA_LOW_EMPHASIS"
					icon="edit"
					(click)="editLetterhead()"
					[testHook]="testHooks.EditLetterheadButton"
				/>
				<ui-button
					label="Edit Footer"
					preset="EXTRA_LOW_EMPHASIS"
					icon="edit"
					(click)="editFooter()"
					[testHook]="testHooks.EditFooterButton"
				/>
			</ng-container>
			<form
				#hstForm="ngForm"
				class="flex"
				(ngSubmit)="submitHstRegistrationNumber(hstForm)"
			>
				<app-input
					label="HST Registration number"
					name="hstRegistrationNumber"
					hstRegistrationNumberFormat
					[(ngModel)]="hstRegistrationNo"
					[submitted]="hstForm.submitted"
				></app-input>
				<div class="flex items-end" *ngIf="hstForm.dirty">
					<app-button
						[disabled]="!hstForm.dirty || !hstForm.valid"
						type="submit"
						size="small"
						class="ml-2"
						[testHook]="testHooks.SaveButton"
						>Save</app-button
					>
				</div>
			</form>
		</div>
		<div>
			<span>Firm Logo</span>
			<div class="flex flex-col xl:flex-row gap-4">
				@if (logoFile) {
					<div class="flex flex-col items-center shrink-0">
						<div
							class="relative w-60 h-60 rounded cursor-pointer overflow-hidden transition-all duration-200 ease-in-out"
							(click)="viewLogo()"
							[testHook]="testHooks.ViewLogoDiv"
						>
							<img
								[src]="logoFile?.url"
								[alt]="logoFile?.name"
								class="w-full h-full rounded object-contain aspect-square"
							/>
							<div
								class="absolute inset-0 flex justify-center items-center bg-gray-500 bg-opacity-70 opacity-0 hover:opacity-100 transition-opacity duration-200 ease-in-out"
							>
								<app-icon
									[icon]="ICON.OVERVIEW"
									class="text-gray-300 text-2xl"
								></app-icon>
							</div>
						</div>
					</div>
					<div class="flex flex-col gap-2">
						<p class="text-gray-500 text-sm">
							For ideal quality upload images that are in square format at a
							minimum resolution of 500x500px.
						</p>
						<ui-button
							size="small"
							preset="DANGER"
							icon="trash"
							class="self-start"
							(click)="resetLogo()"
							label="Delete logo"
							[testHook]="testHooks.DeleteLogoButton"
						></ui-button>
					</div>
				} @else {
					<app-file-upload
						type="dropzone"
						class="w-60 h-60 shrink-0"
						(fileSelected)="fileSelected($event)"
						(success)="onSuccess($event)"
						[docId]="docId_()"
						[fileTypes]="FILE_IMAGE_TYPES"
						[testHook]="testHooks.LogoDropzone"
					>
					</app-file-upload>
					<p class="xl:mt-6 text-gray-500 text-sm">
						For ideal quality upload images that are in square format at a
						minimum resolution of 500x500px.
					</p>
				}
			</div>
		</div>
	</div>
</ui-section>

<section class="mt-6">
	<div class="flex items-center mb-4">
		<h3 class="mr-5">Offices</h3>
		<app-button
			size="small"
			btn="primary"
			[icon]="ICON.ADD"
			(click)="addAddress()"
			[testHook]="testHooks.AddNewOfficeButton"
			>Add new office</app-button
		>
	</div>

	<div
		class="flex flex-wrap gap-6"
		*ngFor="let address of addresses; trackBy: addressTrackBy"
	>
		<atomic-contact-card
			class="max-w-500 mb-5"
			[actions]="actions[address.id]"
			[address]="address"
			[allowDelete]="addresses.length > 1"
			allowEdit="true"
			(deleteContactEvent)="deleteAddress($event)"
			(editContactEvent)="editAddress($event)"
			[email]="address.email"
			[id]="address.id"
			[name]="address.officeName || ''"
			[imageUrl]="address.logoFile?.url"
			[primary]="address.primary"
			[phone]="address.phoneNumber"
			[testHook]="testHooks.OfficeContactCard"
		></atomic-contact-card>
	</div>
</section>
